import type { TableColumns } from '@ohpen/enso-ui';
import { ProcurationFeesExport } from './interfaces';
import { FieldType, ProcurationFeeItem, ProcurationFeeItemsResponse, ProcurationFeeRuleResponse, DraftProcurationFeeItem } from '@pmp/api';

export const procurationFeeColumns: TableColumns<ProcurationFeeItemsResponse> = [
  {
    title: 'lender.procurationFees.labels.id',
    dataIndex: 'id',
    key: 'id',
    width: 290,
    fixed: 'left',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.name',
    dataIndex: 'name',
    key: 'name',
    width: 330,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  { title: 'enso.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

export const procurationFeeFeesColumns: TableColumns<ProcurationFeeItem> = [
  {
    title: 'lender.procurationFees.labels.index',
    dataIndex: 'feTableIndex',
    key: 'feTableIndex',
    width: 120,
    options: {
      sorter: true,
      filter: 'search',
      hide: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.typeId',
    dataIndex: 'procurationFeeItemType',
    key: 'typeId',
    width: 160,
    options: {
      sorter: true,
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.PROCURATION_FEE_ITEM_TYPE,
      required: true,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.type',
    dataIndex: 'procurationFeeItemType',
    key: 'type',
    width: 110,
    options: {
      sorter: true,
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.PROCURATION_FEE_ITEM_TYPE,
    },
  },
  {
    title: 'lender.procurationFees.labels.value',
    dataIndex: 'value',
    key: 'value',
    width: 120,
    options: {
      sorter: true,
      format: {
        type: 'number',
      },
      filter: 'number',
    },
  },
  {
    title: 'lender.procurationFees.labels.unitId',
    dataIndex: 'unit',
    key: 'unitId',
    width: 160,
    options: {
      sorter: true,
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.PROCURATION_FEE_UNIT,
      hide: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.unit',
    dataIndex: 'unit',
    key: 'unit',
    width: 110,
    options: {
      sorter: true,
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.PROCURATION_FEE_UNIT,
    },
  },
  {
    title: 'lender.procurationFees.labels.basisId',
    dataIndex: 'basis',
    key: 'basisId',
    width: 200,
    options: {
      sorter: true,
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.PROCURATION_FEE_BASIS,
      hide: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.basis',
    dataIndex: 'basis',
    key: 'basis',
    width: 150,
    options: {
      sorter: true,
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.PROCURATION_FEE_BASIS,
    },
  },
  {
    title: 'lender.procurationFees.labels.startingMonth',
    dataIndex: 'startingMonth',
    key: 'startingMonth',
    width: 190,
    options: {
      sorter: true,
      format: {
        type: 'number',
      },
      filter: 'number',
      required: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.periodInMonths',
    dataIndex: 'intervalInMonths',
    key: 'intervalInMonths',
    width: 200,
    options: {
      sorter: true,
      format: {
        type: 'number',
      },
      filter: 'number',
      required: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.endingTypeId',
    dataIndex: 'endingType',
    key: 'endingTypeId',
    width: 260,
    options: {
      sorter: true,
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.ENDING_TYPE,
      hide: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.endingType',
    dataIndex: 'endingType',
    key: 'endingType',
    width: 150,
    options: {
      sorter: true,
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.ENDING_TYPE,
    },
  },
];

export const procurationFeeFlatColumns: TableColumns<ProcurationFeesExport> = [
  {
    title: 'lender.procurationFees.labels.id',
    dataIndex: 'id',
    key: 'id',
    fixed: 'left',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.name',
    dataIndex: 'name',
    key: 'name',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.index',
    dataIndex: 'index',
    key: 'index',
    options: {
      sorter: true,
      filter: 'search',
      hide: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.typeId',
    dataIndex: 'procurationFeeItemType',
    key: 'procurationFeeItemType',
    options: {
      sorter: true,
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.PROCURATION_FEE_ITEM_TYPE,
      required: true,
      hide: true,
      hideInForm: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.type',
    dataIndex: 'procurationFeeItemType',
    key: 'procurationFeeItemType',
    options: {
      sorter: true,
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.PROCURATION_FEE_ITEM_TYPE,
    },
  },
  {
    title: 'lender.procurationFees.labels.value',
    dataIndex: 'value',
    key: 'value',
    options: {
      sorter: true,
      format: {
        type: 'number',
      },
      filter: 'number',
    },
  },
  {
    title: 'lender.procurationFees.labels.unitId',
    dataIndex: 'unit',
    key: 'unitId',
    options: {
      sorter: true,
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.PROCURATION_FEE_UNIT,
      hide: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.unit',
    dataIndex: 'unit',
    key: 'unit',
    options: {
      sorter: true,
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.PROCURATION_FEE_UNIT,
    },
  },
  {
    title: 'lender.procurationFees.labels.basisId',
    dataIndex: 'basis',
    key: 'basisId',
    options: {
      sorter: true,
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.PROCURATION_FEE_BASIS,
      hide: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.basis',
    dataIndex: 'basis',
    key: 'basis',
    options: {
      sorter: true,
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.PROCURATION_FEE_BASIS,
    },
  },
  {
    title: 'lender.procurationFees.labels.startingMonth',
    dataIndex: 'startingMonth',
    key: 'startingMonth',
    options: {
      sorter: true,
      format: {
        type: 'number',
      },
      filter: 'number',
    },
  },
  {
    title: 'lender.procurationFees.labels.periodInMonths',
    dataIndex: 'intervalInMonths',
    key: 'intervalInMonths',
    options: {
      sorter: true,
      format: {
        type: 'number',
      },
      filter: 'number',
    },
  },
  {
    title: 'lender.procurationFees.labels.endingTypeId',
    dataIndex: 'endingType',
    key: 'endingTypeId',
    options: {
      sorter: true,
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.ENDING_TYPE,
      hide: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.endingType',
    dataIndex: 'endingType',
    key: 'endingType',
    options: {
      sorter: true,
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.ENDING_TYPE,
    },
  },
];

export const procurationFeeCrColumns: TableColumns<DraftProcurationFeeItem> = [
  {
    title: 'lender.procurationFees.labels.id',
    dataIndex: 'id',
    key: 'id',
    width: 290,
    fixed: 'left',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.name',
    dataIndex: 'name',
    key: 'name',
    width: 330,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.index',
    dataIndex: 'index',
    key: 'index',
    width: 120,
    options: {
      sorter: true,
      filter: 'search',
      hide: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.type',
    dataIndex: 'procurationFeeItemType',
    key: 'procurationFeeItemType',
    width: 110,
    options: {
      sorter: true,
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.PROCURATION_FEE_ITEM_TYPE,
    },
  },
  {
    title: 'lender.procurationFees.labels.value',
    dataIndex: 'value',
    key: 'value',
    width: 120,
    options: {
      sorter: true,
      format: {
        type: 'number',
      },
      filter: 'number',
    },
  },
  {
    title: 'lender.procurationFees.labels.unit',
    dataIndex: 'unit',
    key: 'unit',
    width: 110,
    options: {
      sorter: true,
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.PROCURATION_FEE_UNIT,
    },
  },
  {
    title: 'lender.procurationFees.labels.basis',
    dataIndex: 'basis',
    key: 'basis',
    width: 150,
    options: {
      sorter: true,
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.PROCURATION_FEE_BASIS,
    },
  },
  {
    title: 'lender.procurationFees.labels.startingMonth',
    dataIndex: 'startingMonth',
    key: 'startingMonth',
    width: 190,
    options: {
      sorter: true,
      format: {
        type: 'number',
      },
      filter: 'number',
    },
  },
  {
    title: 'lender.procurationFees.labels.periodInMonths',
    dataIndex: 'intervalInMonths',
    key: 'intervalInMonths',
    width: 200,
    options: {
      sorter: true,
      format: {
        type: 'number',
      },
      filter: 'number',
    },
  },
  {
    title: 'lender.procurationFees.labels.endingType',
    dataIndex: 'endingType',
    key: 'endingType',
    width: 150,
    options: {
      sorter: true,
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.ENDING_TYPE,
    },
  },
];

export const procurationFeeRuleColumns: TableColumns<ProcurationFeeRuleResponse> = [
  {
    title: 'lender.procurationFees.labels.id',
    dataIndex: 'id',
    key: 'id',
    width: 290,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.name',
    dataIndex: 'name',
    key: 'name',
    width: 330,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.procurationFees.labels.operationType',
    dataIndex: 'operationType',
    key: 'operationType',
    width: 230,
    options: {
      sorter: true,
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.OPERATION_TYPE,
    },
  },
  {
    title: 'lender.procurationFees.labels.applicationType',
    dataIndex: 'applicationType',
    key: 'applicationType',
    width: 240,
    options: {
      sorter: true,
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.APPLICATION_TYPE,
    },
  },
  {
    title: 'lender.procurationFees.labels.propertyPurpose',
    dataIndex: 'propertyPurpose',
    key: 'propertyPurpose',
    width: 240,
    options: {
      sorter: true,
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.PROPERTY_PURPOSE,
    },
  },
  { title: 'enso.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];
